/** @jsxImportSource @emotion/react */
import React, { Fragment, useEffect, useState } from 'react';

import { EMPTY_STRING } from '../../const';
import publicPath from '../../utils/publicPath';
import Image from '../Image';
import Text from '../Text';
import useStyles from './styles';

export const getformatFixtureDate = selectedDate => {
  if (!selectedDate) return EMPTY_STRING;
  const dateOj = selectedDate.split(' ');
  const day = selectedDate?.substring(6, 8);
  const month = selectedDate?.substring(4, 6);
  const year = selectedDate?.substring(2, 4);
  return `${day}/${month}/${year} - ${dateOj[1]}`;
};

const MatchDetails = ({
  title,
  matchDateTime,
  locationAddress,
  leagueName,
  homeTeamName,
  roadTeamName,
  agegroup,
  hasAddress,
  ...rest
}) => {
  const styles = useStyles();
  const [homeName, setHomeName] = useState([]);
  const [roadName, setRoadName] = useState([]);

  useEffect(() => {
    if (!homeTeamName || !roadTeamName) {
      return;
    }
    const homeName = homeTeamName.split(agegroup);
    const roadName = roadTeamName.split(agegroup);
    setHomeName(homeName);
    setRoadName(roadName);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeTeamName, roadTeamName]);

  return (
    <div css={styles.matchDetailsWrapper(hasAddress)}>
      <div css={styles.facilitiesWrapper(hasAddress)}>
        <div css={styles.infoFacilities}>
          <Text as="h2" size="7" css={styles.title}>
            {title}
          </Text>
          <Text as="h3" size="6" css={styles.subtitle}>
            <span css={styles.theLeague}>{leagueName}</span>
          </Text>
        </div>
        <Fragment>
          <div css={[styles.fixturesTeam, styles.homeNameWrapper]}>
            <div css={styles.nextFixture}>
              <Text
                as="div"
                css={[styles.nextFixtureName, styles.homeNameFixture]}
                aria-label={homeTeamName}
              >
                <span css={styles.nextHome}>{homeName[0]}</span>
                <Text as="div" css={styles.ageGroupHome}>
                  {agegroup} {homeName[1]}
                </Text>
              </Text>
              <Text as="div">
                <div css={styles.imgWrapper}>
                  <Image
                    id="homeTeamLogo"
                    css={styles.image}
                    src={publicPath(`/images/common/ef-emblem.svg`)}
                    alt="logo for home team"
                  />
                </div>
              </Text>
            </div>
            <div css={styles.fixturesSplit}>
              {!rest.homeScore && (
                <Text
                  as="p"
                  css={styles.fixturesSplitVersus}
                  aria-label="Versus"
                >
                  vs
                </Text>
              )}
              {rest.homeScore && (
                <Text
                  as="p"
                  css={styles.fixturesSplitScore}
                  aria-label="Versus"
                >
                  {rest.homeScore} - {rest.roadScore}
                </Text>
              )}
            </div>
            <div css={[styles.nextFixture, styles.roadNameWrapper]}>
              <Text as="div">
                <div css={styles.imgWrapper}>
                  <Image
                    id="homeTeamLogo"
                    css={styles.image}
                    src={publicPath(`/images/common/ef-emblem.svg`)}
                    alt="logo for home team"
                  />
                </div>
              </Text>
              <Text
                as="div"
                css={[styles.nextFixtureName, styles.roadNameAgeGroup]}
                aria-label={roadTeamName}
              >
                <span css={styles.nextRoad}>{roadName[0]}</span>
                <Text as="div" css={styles.roadNameAgeGroup}>
                  {agegroup} {roadName[1]}
                </Text>
              </Text>
            </div>
          </div>
        </Fragment>
      </div>
      <div css={styles.address}>
        <div css={styles.addressContainer}>
          <div css={styles.mapIcon}></div>
          <div>
            <Text as="p" css={styles.locationAddress}>
              <span css={styles.matchAddress}>{rest.venueName}</span>
            </Text>
            <Text as="p" css={styles.matchDateTime}>
              {getformatFixtureDate(rest.fixtureDate)}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatchDetails;